import React, { useState } from "react";
import { IMG } from "../../lib/site";

const SWATCHES = [
  {
    id: "silver-metallic",
    name: "Silver Metallic",
    testid: "visualizer-swatch-silver-metallic",
    swatch: "bg-gradient-to-br from-zinc-300 via-zinc-100 to-zinc-500",
    image: IMG.metallic,
    description: "Our signature high-gloss, marble-like reflective metallic. Perfect for premium garages and custom showrooms.",
  },
  {
    id: "classic-gray",
    name: "Classic Gray Flake",
    testid: "visualizer-swatch-classic-gray",
    swatch: "bg-zinc-600",
    image: IMG.grayFlake,
    description: "Heavy-broadcast gray flake with a polyaspartic topcoat. Built for lifetime durability and slip resistance.",
  },
  {
    id: "gloss-black",
    name: "High-Gloss Black",
    testid: "visualizer-swatch-gloss-black",
    swatch: "bg-zinc-950 border border-zinc-700",
    image: IMG.blackGarage,
    description: "A dramatic, mirror-finish black coating that turns an ordinary garage into a true showpiece.",
  },
  {
    id: "copper-metallic",
    name: "Copper Metallic",
    testid: "visualizer-swatch-warm-taupe",
    swatch: "bg-gradient-to-br from-[#b5774a] via-[#d89b63] to-[#7a4a2a]",
    image: IMG.metallicCopper,
    description: "A stunning poured copper metallic floor with deep, marble-like movement — a true centerpiece for living spaces.",
  },
];

const FloorVisualizer = () => {
  const [active, setActive] = useState(SWATCHES[0]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch border border-zinc-800 p-5 md:p-8 bg-zinc-950">
      <div className="lg:col-span-8 overflow-hidden relative aspect-auto sm:aspect-[16/10] border border-zinc-800 bg-zinc-950">
        <img
          src={active.image}
          alt={active.name}
          className="w-full h-auto sm:h-full object-contain sm:object-cover transition-all duration-700 ease-out"
          data-testid="visualizer-main-image"
        />
        <div className="relative sm:absolute sm:bottom-0 inset-x-0 bg-black/90 backdrop-blur-md p-4 border-t border-zinc-800">
          <p className="text-[#C69453] text-xs uppercase tracking-widest font-semibold">Active Finish</p>
          <h4 className="text-xl font-semibold text-white mt-1">{active.name}</h4>
          <p className="text-zinc-400 text-sm mt-1">{active.description}</p>
        </div>
      </div>

      <div className="lg:col-span-4 flex flex-col justify-between">
        <div>
          <span className="text-[#C69453] text-xs font-semibold tracking-[0.2em] uppercase">Interactive Tool</span>
          <h3 className="text-2xl md:text-3xl font-light text-white mt-2">Pick Your Finish</h3>
          <p className="text-zinc-400 text-sm mt-2 leading-relaxed">
            Tap a finish below to see how your custom floor could look once it's installed with extreme care.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3 mt-6">
          {SWATCHES.map((s) => (
            <button
              key={s.id}
              onClick={() => setActive(s)}
              data-testid={s.testid}
              className={`p-4 border text-left transition-all duration-300 flex flex-col justify-between h-28 ${
                active.id === s.id
                  ? "border-[#C69453] bg-[#C69453]/5 text-white"
                  : "border-zinc-800 bg-zinc-900/50 hover:border-zinc-700 text-zinc-400"
              }`}
            >
              <div className={`w-8 h-8 ${s.swatch} shadow`} />
              <span className="text-sm font-semibold block">{s.name}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FloorVisualizer;
